import { SearchModel } from "./search";
import { AppSettings } from "../../app-settings";
import {AuthorizationModel} from "../../authentication/models/authorization-model";
import {prop} from "../../decorators/property";
import { AppEvents } from "../../app-events";
import { Container } from "aurelia-dependency-injection";
import { ContainerHelper } from "../../shared/helpers/container-helper";

export class SearchAlertModel extends Backbone.Model {
    @prop() public name = "";
    @prop() public subject = "";
    @prop() public frequency = "";
    @prop() public recipient = "";
    @prop() public userid: number;
    @prop() public enabled = false;
    @prop() public search: any;

    private appEvents: Backbone.Events;

    constructor() {
        super();
        this.appEvents = ContainerHelper.Events;
    }

    public saveSearchAlert(): Promise<any> {
        const data = this.toJSON();
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                url: `${AppSettings.ApiUrlPrefix}alerts/search/add`,
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                method: "POST",
                data
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/search-alert.ts